import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PageContentLayout } from '@tassomutuo-backoffice/ui';
import { Profile } from '@tassomutuo-backoffice/types';
import ModalProfileForm from './components/ModalProfileForm';
import IntranetUsersTable from './components/IntranetUsersTable';
import ProfilesTable from './components/ProfilesTable';
import {
  createIntranetUserWithTassoProfile,
  putTassomutuoProfile,
} from '../../../services/api/profile/profile';

const ProfilesListPage = () => {
  const queryClient = useQueryClient();
  const [profileSelected, setProfileSelected] = useState<Profile | null>(null);
  const [showModalForm, setShowModalForm] = useState(false);

  const onEditRowClick = (profile: Profile) => {
    setProfileSelected(profile);
  };

  const putProfileMutation = useMutation({
    mutationFn: putTassomutuoProfile,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: ['Profiles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['IntranetUsers'],
      });
      toast.success('Profilo aggiornato!');
    },
    onError: (error) => {
      toast.error(error.message || 'Si è verificato un errore, riprova!');
    },
  });

  const createIntranetUserWithTassoProfileMutation = useMutation({
    mutationFn: createIntranetUserWithTassoProfile,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: ['Profiles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['IntranetUsers'],
      });
      toast.success('Utenza creata!');
    },
    onError: (error) => {
      toast.error(error.message || 'Si è verificato un errore, riprova!');
    },
  });

  const closeModalForm = () => {
    setProfileSelected(null);
    setShowModalForm(false);
  };

  return (
    <>
      <PageContentLayout title="Gestione Profili" error={null}>
        <ProfilesTable onEditRowClick={onEditRowClick} />
        <IntranetUsersTable
          onEditRowClick={onEditRowClick}
          onCreateNewClick={() => setShowModalForm(true)}
        />
      </PageContentLayout>
      <ModalProfileForm
        open={!!profileSelected || showModalForm}
        profileToUpdate={profileSelected}
        handleClose={closeModalForm}
        onSubmitProfileToUpdate={putProfileMutation.mutateAsync}
        onSubmitProfileToCreate={
          createIntranetUserWithTassoProfileMutation.mutateAsync
        }
      />
    </>
  );
};

export default ProfilesListPage;
